'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serializeThreadForExternalEvent = undefined;

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var serializeThreadForExternalEvent = exports.serializeThreadForExternalEvent = function serializeThreadForExternalEvent(thread) {
  return {
    conversationId: (0, _threadGetters.getThreadId)(thread)
  };
};